import type { ReactNode } from "react";

export function MetaRow({ children }: { children: ReactNode }) {
  return <div className="meta-row">{children}</div>;
}

export function MetaChip({ value, label }: { value: ReactNode; label?: ReactNode }) {
  return (
    <div className="meta-chip">
      <strong>{value}</strong>
      {label != null && <> {label}</>}
    </div>
  );
}
